const NETLIFY_FUNCTIONS_API_BASE =
  'https://clinical-trial-expertise.netlify.app/.netlify/functions/api';

function isFirebaseHostedDomain(hostname: string): boolean {
  return hostname.endsWith('.web.app') || hostname.endsWith('.firebaseapp.com');
}

export function isFirebaseHostedRuntime(): boolean {
  return typeof window !== 'undefined' && isFirebaseHostedDomain(window.location.hostname);
}

export function getApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (isFirebaseHostedRuntime()) {
    return `${NETLIFY_FUNCTIONS_API_BASE}${normalizedPath}`;
  }

  return `/api${normalizedPath}`;
}
